<template>
    <div id="ticket"> 
        <v-container>
        <v-row>
            <h2>Liga: {{ tickets[league_id].leagueName.toUpperCase() }}</h2>
        </v-row>
        
        <v-row>
            <h3>Organizator: {{ tickets[league_id].leagueAdmin.toUpperCase() }}</h3>
        </v-row>
        <v-row  class="justify-center">
            <v-col cols="12" sm="12" md="6" v-for="(item,index) in tickets[league_id].races" :key="index">
                <v-card class="mb-5" elevation="3">
                    <v-row class="no-gutters">
                        <v-col cols="12" sm="6" lg="6">
                            <v-card-title>{{item.raceName}}</v-card-title>
                            <v-card-subtitle class="pb-0">{{item.raceDate}}</v-card-subtitle>
                        </v-col>
                        <v-col cols="12" sm="6" lg="6">  
                            <v-card-title right>
                                Liga: {{ tickets[league_id].leagueName.toUpperCase() }}
                                <v-icon class="ml-3" color="#76EB6C">fa-flag-checkered</v-icon>
                            </v-card-title> 
                        </v-col>  
                    </v-row>
                    <v-row class="no-gutters">
                        <v-col cols="12" sm="12" md="6" lg="4">
                            <div class="d-flex flex-column">
                                <v-card-text class="text--primary">
                                    <div>Numer startowy: {{ item.raceNumber }}</div>
                                    <div>Lokalizacja: {{ item.raceLocalization }}</div>
                                    <div>Cena {{ item.paidPrice }} zł</div>
                                </v-card-text>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="4">
                            <div class="d-flex flex-column">
                                <v-card-text class="text--primary">
                                    <div>Wybrany pojazd:</div>
                                    <div>Pojazd: {{ $store.state.userData.cars[0].Manufacture }} {{$store.state.userData.cars[0].carModel}}</div>
                                    <div>Rok: {{$store.state.userData.cars[0].carYear}}</div>
                                    <div>Pojemność: {{$store.state.userData.cars[0].carEngineCapacity}}cm3</div>
                                </v-card-text>
                            </div>    
                        </v-col>
                        <v-col cols="12" sm="12" lg="4">
                            <div class="d-flex flex-column">
                             <v-img contain :src="$store.state.userData.cars[0].carImage"></v-img>
                            </div>
                        </v-col>
                    </v-row>

                </v-card>
            </v-col>
        </v-row>
        </v-container>
        <v-divider></v-divider>
    </div>
</template>
<script>
export default {
    name:'ticket',
    props:['league_id'],
    data(){
        return{
        }
    },
    computed:{
        tickets(){
            return  this.$store.state.userData.tickets
        }
    }
}
</script>